// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1LADL","question":"Question_question__3Rq5G","description":"Question_description__-XweR"};